import React, { useCallback, useEffect, useState } from 'react';
import s from '../../pages/PDV.module.css';
import { listFilaCompleta, marcarPendenteNovamente, removerDaFila } from '../../services/offlineDb';

const fmtBRL = v =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const LABEL_STATUS = {
  pendente: 'Aguardando conexão',
  sincronizando: 'Sincronizando…',
  erro: 'Não sincronizou — revisar',
};

/**
 * Painel de vendas do PDV que ficaram na fila local (offline) — mostra o
 * que está esperando a internet voltar e o que precisa de revisão manual
 * (o servidor recusou de verdade, ex: estoque insuficiente enquanto a
 * venda ficou pendente). Reaproveita os estilos de modal já usados no
 * ModalCliente (mesmo PDV.module.css).
 */
export default function PainelSincronizacao({ aberto, onFechar, sincronizarAgora }) {
  const [fila, setFila] = useState([]);

  const recarregar = useCallback(async () => {
    setFila(await listFilaCompleta());
  }, []);

  useEffect(() => {
    if (!aberto) return;
    recarregar();
    const t = setInterval(recarregar, 3000);
    return () => clearInterval(t);
  }, [aberto, recarregar]);

  if (!aberto) return null;

  const tentarNovamente = async (uuid) => {
    await marcarPendenteNovamente(uuid);
    await recarregar();
    sincronizarAgora();
  };

  const descartar = async (uuid) => {
    if (!window.confirm('Descartar esta venda pendente? Ela NÃO será enviada pro servidor.')) return;
    await removerDaFila(uuid);
    await recarregar();
  };

  return (
    <div className={s.modalOverlay} onClick={onFechar}>
      <div className={s.modalCliente} style={{ width: 480 }} onClick={e => e.stopPropagation()}>
        <div className={s.modalTitleBar}>
          <span>Pendências de sincronização</span>
          <button className={s.modalClose} onClick={onFechar}>✕</button>
        </div>
        <div className={s.modalBody}>
          {fila.length === 0 ? (
            <p className={s.semResultado}>Nenhuma venda pendente — tudo sincronizado.</p>
          ) : (
            fila.map(item => (
              <div key={item.uuid} className={s.filaSyncItem}>
                <div className={s.filaSyncInfo}>
                  <span className={s.filaSyncValor}>{fmtBRL(item.payload?.total_pago ?? item.payload?.total)}</span>
                  <span className={item.status === 'erro' ? s.filaSyncStatusErro : s.filaSyncStatus}>
                    {LABEL_STATUS[item.status] || item.status}
                  </span>
                  {item.status === 'erro' && item.erro_msg && (
                    <span className={s.filaSyncErroMsg}>{item.erro_msg}</span>
                  )}
                </div>
                {item.status === 'erro' && (
                  <div className={s.filaSyncAcoes}>
                    <button type="button" onClick={() => tentarNovamente(item.uuid)}>↻ Tentar de novo</button>
                    <button type="button" onClick={() => descartar(item.uuid)}>🗑️ Descartar</button>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
        <div className={s.modalFooter}>
          <button type="button" className={s.btnCancelarModal} onClick={onFechar}>Fechar</button>
        </div>
      </div>
    </div>
  );
}
